import './IconHeartFilled.css';
import React from 'react';
var IconHeart = function IconHeart(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className, " ").concat(styles),
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.376,4.9l9.118-1.42c-2.023-1.973-5.251-1.973-7.273,0L10,3.7L9.779,3.48\r c-2.022-1.973-5.25-1.973-7.272,0c-1.975,1.93-2.011,5.096-0.081,7.071c0.027,0.027,0.054,0.055,0.081,0.081L10,18l7.494-7.368\r c1.975-1.93,2.012-5.096,0.081-7.07c-0.026-0.027-0.054-0.055-0.081-0.082"
  }));
};
var styles = "s1ojwqga";
export default IconHeart;